import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';

import Publications from 'components/BKantarciPublications/Publications';

import MobileFooter from 'components/MobileFooter';
import { useEffect } from "react";

function Kantarcipublication() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <>
    {isMobile ? (
      <>
        <MobileNavbar />
        <Publications/>
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <Publications/>
        <Footer />
      </>
    )}
    </>
  );
}

export default Kantarcipublication;
